import React from 'react';
import { Card } from '../common/Card';
import { StatusBadge } from '../common/StatusBadge';
import { mockSongs } from '../../data/mockData';

export const DistributionStatus: React.FC = () => {
  const statusCounts = mockSongs.reduce((acc, song) => {
    acc[song.status] = (acc[song.status] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);
  
  const recentSongs = mockSongs.slice(0, 5);
  
  return (
    <Card>
      <h3 className="text-lg font-semibold text-white font-display mb-6">Distribution Status</h3>
      
      {/* Status Overview */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="text-center p-3 bg-green-500/10 rounded-lg border border-green-500/20">
          <p className="text-2xl font-bold text-green-400">{statusCounts.live || 0}</p>
          <p className="text-sm text-gray-400">Live</p>
        </div>
        <div className="text-center p-3 bg-yellow-500/10 rounded-lg border border-yellow-500/20">
          <p className="text-2xl font-bold text-yellow-400">{statusCounts.pending || 0}</p>
          <p className="text-sm text-gray-400">Pending</p>
        </div>
        <div className="text-center p-3 bg-red-500/10 rounded-lg border border-red-500/20">
          <p className="text-2xl font-bold text-red-400">{statusCounts.failed || 0}</p>
          <p className="text-sm text-gray-400">Failed</p>
        </div>
        <div className="text-center p-3 bg-gray-500/10 rounded-lg border border-gray-500/20">
          <p className="text-2xl font-bold text-gray-400">{statusCounts.taken_down || 0}</p>
          <p className="text-sm text-gray-400">Taken Down</p>
        </div>
      </div>
      
      {/* Recent Songs */}
      <div className="space-y-3">
        <h4 className="text-sm font-medium text-gray-300">Recent Uploads</h4>
        {recentSongs.map((song) => (
          <div key={song.id} className="flex items-center justify-between p-3 bg-gray-800/50 rounded-lg">
            <div className="flex items-center space-x-3">
              <img
                src={song.coverArt}
                alt={song.title}
                className="w-10 h-10 rounded-lg object-cover"
              />
              <div>
                <p className="text-sm font-medium text-white">{song.title}</p>
                <p className="text-xs text-gray-400">{song.artist}</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <span className="text-xs text-gray-400">{song.stores.length} stores</span>
              <StatusBadge status={song.status} />
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};